/* export const currentRoles = ( state ) => {
    return state.roles
}
 */
export const currentUser = ( state ) => {
    return state.user
}

export const getStatus = ( state ) => {
    return state.status
}

export const currentRole = () => {
    return localStorage.getItem('currentRole')
}